( function ( $ ) {
	const slider = function ( $block ) {
		const $slider = $block.find( '.partners-slider' );

		$slider.not( '.slick-initialized' ).slick( {
			infinite: true,
			arrows: false,
			dots: false,
			slidesToShow: 6,
			slidesToScroll: 1,
			rows: 0,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						autoplay: true,
						slidesToShow: 4,
						slidesToScroll: 1,
					},
				},
			],
		} );
	};

	// Initialize each block on page load (front end).
	$( function () {
		$( '.partners-block' ).each( function () {
			slider( $( this ) );
		} );
	} );

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction(
			'render_block_preview/type=partners-block',
			slider
		);
	}
} )( jQuery );
